import { Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../actions/tenantActions';
import ServiceSettingsForm from './ServiceSettingsForm';

const ServiceSettingsPage = () => {
  const dispatch = useDispatch();
  const tenant = useSelector(s => s.tenant);
  const {
    batteryLevelAlertThresholdPercentage,
    hideElectricBikeByBatteryLevelThresholdPercentage,
    lockDelayAlertThresholdInMinutes,
    maximumTimeBetweenServiceDays,
    outOfZoneAlertThresholdInMinutes,
    messageForUser,
    longRidePushIntervalInHours,
    automaticBikeRestrictRentalsByDefectQuantity,
    automaticBikeRestrictRentalsCountingMode,
    minimumDayToHideBikeAfterLoseGPS
  } = tenant;
  const handleSubmit = (data) => {
    dispatch(actions.updateServiceSettings(data))
  };

  return (
    <div className="page" >
      <div style={{ margin: 40, paddingBottom: 20 }}>
        <Typography variant="h5" gutterBottom>Konfiguracja</Typography>
          <ServiceSettingsForm
            initialValues={{
              batteryLevelAlertThresholdPercentage,
              hideElectricBikeByBatteryLevelThresholdPercentage,
              lockDelayAlertThresholdInMinutes,
              maximumTimeBetweenServiceDays,
              outOfZoneAlertThresholdInMinutes,
              longRidePushIntervalInHours,
              maximumTimeBetweenServiceEnabled: maximumTimeBetweenServiceDays !== null,
              lockDelayAlertEnabled: lockDelayAlertThresholdInMinutes !== null,
              outOfZoneAlertEnabled: outOfZoneAlertThresholdInMinutes !== null,
              batteryLevelAlertEnabled: batteryLevelAlertThresholdPercentage !== null,
              hideElectricBikeByBatteryLevelEnabled: hideElectricBikeByBatteryLevelThresholdPercentage !== null,
              longRidePushEnabled: longRidePushIntervalInHours !== null,
              messageForUser,
              automaticBikeRestrictRentalsByDefectQuantity,
              automaticBikeRestrictRentalsCountingMode: automaticBikeRestrictRentalsCountingMode || 'sameBikePart',
              automaticBikeRestrictRentalsByDefectQuantityEnabled: automaticBikeRestrictRentalsByDefectQuantity !== null,
              minimumDayToHideBikeAfterLoseGPS,
              minimumDayToHideBikeAfterLoseGPSEnabled: minimumDayToHideBikeAfterLoseGPS !== null
            }}
            onSubmit={handleSubmit}
          />
      </div>
    </div>
  );
}

export default ServiceSettingsPage;
